import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui'
import { showSnackbarAction } from '@root/shared/ui-kit'

import type { TelegramId } from '@root/entities/auth/model/telegram-id'
import type { CurrencyAddress } from '@root/entities/currency'
import type { PremiumId } from '@root/entities/premium'
import type { DelugeId } from '@root/entities/user-short'
import type { WalletAddress } from '@root/entities/wallet'

interface BackOfficePremiumChangePayload {
  premiumId?: PremiumId
  /** Token address (alternative to premiumId) */
  tokenAddress?: CurrencyAddress
  newDelugeId: DelugeId
  newOwnerWalletAddress: WalletAddress
  newTgId?: TelegramId
}

export const reatomBackOfficePremiumChangeRequestAction = action(
  async (ctx, data: BackOfficePremiumChangePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.admin.adminPremiumRevokeCreate, [
        {
          premiumId: data.premiumId || undefined,
          tokenAddress: data.tokenAddress || undefined,
          newDelugeId: data.newDelugeId,
          newOwnerWalletAddress: data.newOwnerWalletAddress,
          newTgId: data.newTgId || undefined,
        },
      ]),
    )

    return result.pipe(
      Result.map((it) => ({
        success: it.success,
      })),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'reatomBackOfficePremiumChangeRequestAction',
)

export const reatomBackOfficePremiumChangeForm = () => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const requestState = reatomRequest({
    execAction: reatomBackOfficePremiumChangeRequestAction,
    async onResult(ctx, result) {
      if (Result.isSuccess(result)) {
        if (result.success.success) {
          showSnackbarAction(ctx, {
            intent: 'success',
            text: i18next.t('back_office.premium.change_success'),
          })
        } else {
          showSnackbarAction(ctx, {
            intent: 'error',
            text: i18next.t('back_office.premium.change_error'),
          })
        }
      } else {
        showErrorSnackbarAction(ctx, result.failure)
      }
    },
  })

  return { requestState }
}
